import React, {useEffect, useState} from 'react'
import {KTCard, KTCardBody, KTIcon} from "../../../../_websoft/helpers"
import {Link, useNavigate} from "react-router-dom"
import {ToastContainer} from "react-toastify"

import {
    flexRender,
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    SortingState,
    useReactTable
} from "@tanstack/react-table"

import TableSearch from "../../../components/TableSearch/TableSearch"
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent"

import moment from "moment"

import notifyToast from "../../../components/Toast/Toast"

import {ParamsModelGlavnaKnjiga} from "../../../models/GlavnaKnjigaModel"

import {
    getDopSifre,
    getPanelWizzardDops
} from "../../../api/paneliDop"

import {TableActionButton} from "../../../components/TableActionBtn/TableActionButton"

import DopSifreModal from "./components/DopSifreModal"
import DopPdfModal from "./components/DopPdfModal"
import IzvjestajiModal from "../components/DopIzvjestaj/IzvjestajiModal"

// ✅ NEW TYPE
type DopWizardRow = {
    id: number
    standard: string
    vrsta_proizvoda: string
    podrucje_primjene: string
    vrsta_ispune: string
    notified_body: string
    sistem: string
    privremeni_dop: number
    broj_naloga: string
    stavka: string
    kreirano: string
}

const DopWizardList = () => {

    const [data, setData] = useState<DopWizardRow[]>([])
    const [loading, setLoading] = useState(true)

    const [showSifraModal, setShowSifraModal] = useState(false)
    const [sifraId, setSifraId] = useState<number | null>(null)

    const [dbSifre, setDbSifre] = useState<any[]>([])
    const [newSifre, setNewSifre] = useState<any[]>([])

    const [showPdfModal, setShowPdfModal] = useState(false)
    const [pdfDopId, setPdfDopId] = useState<number | null>(null)

    const [showIzvjestajiModal, setShowIzvjestajiModal] = useState(false)

    const [pagination, setPagination] = useState({
        curPage: 1,
        totalPage: 1,
        perPage: 10
    })

    const [params, setParams] = useState<ParamsModelGlavnaKnjiga>({
        per_page: 10,
        page: 1
    })

    const [sorting, setSorting] = useState<SortingState>([])
    const [globalFilter, setGlobalFilter] = useState('')

    const navigate = useNavigate()

    // =========================
    // FETCH DATA
    // =========================
    const updatePage = async () => {

        setLoading(true)

        try {

            const res = await getPanelWizzardDops(params)

            const rows = res.data.data.map((item: any) => ({
                id: item.id,
                standard: item.standard,
                vrsta_proizvoda: item.vrsta_proizvoda,
                podrucje_primjene: item.podrucje_primjene,
                vrsta_ispune: item.vrsta_ispune,
                notified_body: item.notified_body,
                sistem: item.sistem,
                privremeni_dop: item.privremeni_dop,
                broj_naloga: item.broj_naloga,
                stavka: item.stavka,
                kreirano: item.kreirano
            }))

            setData(rows)

            setPagination({
                curPage: res.data.current_page,
                totalPage: res.data.last_page,
                perPage: res.data.per_page
            })

        } catch (err: any) {

            console.error(err)

            notifyToast(
                false,
                err.message || 'Greška'
            )

        } finally {

            setLoading(false)

        }
    }

    useEffect(() => {

        updatePage()

    }, [params.page, params.per_page])

    // =========================
    // TABLE COLUMNS
    // =========================
    const columns: any = [

        {
            header: 'ID',
            accessorKey: 'id'
        },

        {
            header: 'Standard',
            accessorKey: 'standard'
        },

        {
            header: 'Vrsta proizvoda',
            accessorKey: 'vrsta_proizvoda'
        },

        {
            header: 'Ispuna',
            accessorKey: 'vrsta_ispune'
        },

        {
            header: 'Obavještajno tijelo',
            accessorKey: 'notified_body'
        },

        {
            header: 'Sistem',
            accessorKey: 'sistem'
        },

        {
            header: 'Privremeni',
            accessorKey: 'privremeni_dop',

            cell: ({row}: any) => (

                row.original.privremeni_dop === 1

                    ? (
                        <span className="badge badge-light-success">
                            DA
                        </span>
                    )

                    : (
                        <span className="badge badge-light-danger">
                            NE
                        </span>
                    )
            )
        },

        {
            header: 'Nalog',
            accessorKey: 'broj_naloga'
        },

        {
            header: 'Stavka',
            accessorKey: 'stavka'
        },

        {
            header: 'Datum',
            accessorKey: 'kreirano',

            cell: ({row}: any) => (

                row.original.kreirano

                    ? moment(
                        row.original.kreirano
                    ).format('DD.MM.YYYY')

                    : ''
            )
        },
        {
            id: 'sifra',

            header: 'Šifra',

            cell: ({row}: any) => (

                <button
                    className="btn btn-sm btn-light-primary"
                    onClick={() => openSifraModal(row.original.id)}
                >
                    <KTIcon
                        iconName='code'
                        className='fs-3'
                    />
                </button>
            )
        },

        {
            id: 'pdf',

            header: 'PDF',

            cell: ({row}: any) => (

                <button
                    className="btn btn-sm btn-light-info"
                    onClick={() => openPdfModal(row.original.id)}
                >
                    <KTIcon
                        iconName="file"
                        className="fs-3"
                    />
                </button>
            )
        },

        {
            id: 'akcija',

            header: 'Akcija',

            cell: ({row}: any) => (

                <TableActionButton

                    onDelete={() =>
                        notifyToast(
                            true,
                            "Record deleted"
                        )
                    }

                    onEdit={() =>
                        navigate(
                            `/paneli/digitalni-dop-wizzard/izmjena/${row.original.id}`
                        )
                    }
                />
            ),
        },
    ]

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),

        state: {
            sorting,
            globalFilter
        },

        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter
    })

    // =========================
    // OPEN SIFRA MODAL
    // =========================
    const openSifraModal = async (id: number) => {

        setSifraId(id)
        setShowSifraModal(true)

        try {

            const data = await getDopSifre(id)

            const sifre = data.map((item: any) => ({
                Id: item.Id,
                sifra: item.sifre_panela?.sifra
            }))

            setDbSifre(sifre)
            setNewSifre([])

        } catch (error) {

            notifyToast(
                false,
                "Greška kod učitavanja šifri"
            )
        }
    }

    // =========================
    // OPEN PDF MODAL
    // =========================
    const openPdfModal = (id: number) => {

        setPdfDopId(id)
        setShowPdfModal(true)
    }

    return (

        <KTCard>

            <ToastContainer/>

            <KTCardBody className='py-4'>

                {/* HEADER */}
                <div className='d-flex justify-content-between align-items-center mb-5 flex-wrap gap-3'>

                    {/* LEFT */}
                    <TableSearch
                        onSearch={(text) =>
                            setGlobalFilter(text)
                        }
                    />

                    {/* RIGHT */}
                    <div className='d-flex align-items-center gap-2'>

                        <button
                            className='btn btn-light-info'
                            onClick={() => setShowIzvjestajiModal(true)}
                        >
                            <KTIcon
                                iconName='chart-line'
                                className='fs-2'
                            />

                            Izvještaji
                        </button>

                        <Link to='dodaj'>

                            <button className='btn btn-primary d-flex align-items-center'>

                                <KTIcon
                                    iconName='plus'
                                    className='fs-4 me-1'
                                />

                                Novi DOP
                            </button>

                        </Link>

                    </div>

                </div>

                {/* TABLE */}
                {loading ? (

                    <LoadingComponent/>

                ) : (

                    <div className='table-responsive'>

                        <table className='table table-bordered align-middle'>

                            <thead>

                            {table.getHeaderGroups().map(headerGroup => (

                                <tr
                                    key={headerGroup.id}
                                    className='bg-dark'
                                >

                                    {headerGroup.headers.map(header => (

                                        <th
                                            key={header.id}
                                            className='text-white'
                                        >

                                            {flexRender(
                                                header.column.columnDef.header,
                                                header.getContext()
                                            )}

                                        </th>

                                    ))}

                                </tr>

                            ))}

                            </thead>

                            <tbody>

                            {table.getRowModel().rows.map(row => (

                                <tr key={row.id}>

                                    {row.getVisibleCells().map(cell => (

                                        <td key={cell.id}>

                                            {flexRender(
                                                cell.column.columnDef.cell,
                                                cell.getContext()
                                            )}

                                        </td>

                                    ))}

                                </tr>

                            ))}

                            </tbody>

                        </table>

                    </div>

                )}

                {/* SIFRE MODAL */}
                <DopSifreModal
                    isOpen={showSifraModal}
                    onClose={() => setShowSifraModal(false)}
                    sifraId={sifraId}
                    dbSifre={dbSifre}
                    setDbSifre={setDbSifre}
                    newSifre={newSifre}
                    setNewSifre={setNewSifre}
                />

            </KTCardBody>

            {/* PDF MODAL */}
            <DopPdfModal
                isOpen={showPdfModal}
                onClose={() => setShowPdfModal(false)}
                dopId={pdfDopId}
            />

            {/* IZVJESTAJI MODAL */}
            <IzvjestajiModal
                show={showIzvjestajiModal}
                onClose={() => setShowIzvjestajiModal(false)}
            />

        </KTCard>
    )
}

export default DopWizardList